import template from './department_search_component.html';

class DepartmentSearchComponentViewModel
{
	constructor(params)
	{
		this.params = params;

		this.departments = ko_helper.safe_observableArray();
		this.selected_department = ko_helper.safe_observable(params.selected_department || '');
		this.selected_company = ko_helper.safe_observable(params.selected_company || '');
		this.search_string = ko.observable('');

		// Computed observable for dynamically updating the placeholder
		this.placeholderText = ko.pureComputed(() => {
			return this.selected_department() != null ? `${this.selected_department().department} (${this.selected_department().company})` : "Search department...";
		});

		this.search_string.subscribe((newValue) => {
			this.updateData();
		});

		this.selected_company.subscribe((val) => {
			this.updateData();
		});
	}

	async init()
	{
		await this.updateData();
	}

	async updateData()
	{
		let options = {
			table: 'v_department_company',
			schema: 'savanna',
			limit: 10000,
			sortfield: 'department',
			sortorder: 'asc'
		};

		// If we have a search string, we need to make two separate queries
		if (this.search_string() && this.search_string().trim() !== '')
		{
			let search_text = this.search_string().trim();

			// First query - search by department name
			let department_options = {
				...options,
				filter: []
			};
			
			if (this.selected_company() && this.selected_company().company_id)
			{
				department_options.filter.push({
					field: 'company_id',
					operand: '=',
					value: this.selected_company().company_id
				});
			}
			
			department_options.filter.push({
				field: 'department',
				operand: 'ILIKE',
				value: `%${search_text}%`
			});

			// Second query - search by company name
			let company_options = {
				...options,
				filter: []
			};
			
			if (this.selected_company() && this.selected_company().company_id)
			{
				company_options.filter.push({
					field: 'company_id',
					operand: '=',
					value: this.selected_company().company_id
				});
			}
			
			company_options.filter.push({
				field: 'company',
				operand: 'ILIKE',
				value: `%${search_text}%`
			});

			// Make both queries
			let [dept_result, company_result] = await Promise.all([
				Grape.fetches.getJSON('/api/record', department_options),
				Grape.fetches.getJSON('/api/record', company_options)
			]);

			// Combine and deduplicate results
			let combined_results = [];
			let seen_ids = new Set();

			if (dept_result.status !== 'ERROR' && dept_result.records)
			{
				dept_result.records.forEach(record => {
					if (!seen_ids.has(record.department_id))
					{
						combined_results.push(record);
						seen_ids.add(record.department_id);
					}
				});
			}

			if (company_result.status !== 'ERROR' && company_result.records)
			{
				company_result.records.forEach(record => {
					if (!seen_ids.has(record.department_id))
					{
						combined_results.push(record);
						seen_ids.add(record.department_id);
					}
				});
			}

			this.departments(combined_results);
		}
		// If we only have company filter or no filters
		else if (this.selected_company() && this.selected_company().company_id)
		{
			let default_options = {
				...options,
				filter: [{
					field: 'company_id',
					operand: '=',
					value: this.selected_company().company_id
				}]
			};

			let result = await Grape.fetches.getJSON('/api/record', default_options);

			if (result.status !== 'ERROR' && result.records != null) 
				this.departments(result.records);
			else 
				this.departments([]);
		}
		else
			this.departments([]);
	}

	department_click(selected)
	{
		this.selected_department(selected);
		this.search_string('');
	}

	clear_selected_option()
	{
		this.selected_department(null);
		this.search_string('');
	}
}

export default {
	name: 'department_search_component',
	viewModel: DepartmentSearchComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/department_search_component'
};